import React from 'react';
import classNames from 'classnames';

export default function CircularPlusIcon({ className = '' }) {
	return <span className={classNames('icon icon-item_add', className)} />;
}
